import { Component } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatDialogClose } from "@angular/material/dialog";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-visit-type-sor-code-add",
  templateUrl: "./visit-type-sor-code-add.component.html",
  styleUrls: ["./visit-type-sor-code-add.component.css"],
  imports: [MatButton, MatDialogClose, RouterLink]
})
export class VisitTypeSorCodeAddComponent {
  constructor() {}
}
